module.exports = __webpack_public_path__ + "static/media/LaszloTorok.5d290b8c.jpg";